export default {
  newDesign: true,
  title:
    "¿Cómo evitar que el cansancio termine en gritos? | Kodland",
  downtimeUrl: "http://kodland.org/es",
  parameters: {
    landing_id: "EsQuTiPaid",
    segment: 14,
    success_page: "success_long",
  },
  startPage: {
    title:
      "Haz el test de 2 minutos y descubre cómo manejar el estrés diario 💙",
    subtitle:
      "✔️ Creado por expertos en crianza y bienestar<br>❤️ 100% gratis<br>🎁 Consejos útiles al finalizar el test<br>👪 Más de 200 mil padres ya confían en nosotros",
    image: {
      url: "/welcome/es_content_tired_paid_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/es_content_tired_paid_mob.png",
      style: {
        width: "100%",
      },
    },
    button: "¡Empezar test! 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "¡Gracias por confiar en nuestra plataforma educativa!",
    subtitle:
      "Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras clases la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question: "¿Qué es lo que más te agobia o te saca de quicio como mamá o papá?",
      answers: [
            "Quejas sin fin 😫",
            "Desorden por toda la casa 🧹",
            "Peleas entre hermano/as 👊",
            "Problemas con la escuela 🎒",
            "Otro 👀",
      ],
    },
    2: {
      question:
        "¿Qué sientes que más alimenta tu estrés o cansancio?",
      answers: [        
        "No tener espacio para mí 😵‍💫",
        "Compararme con otros padres 😔",
        "Hacer mil cosas a la vez 🌀",
        "Discutir con mi pareja 💢",
        "Otro 🤔",
      ],
    },
    3: {
      typeInfo: "noQuestions",
      title: "Mereces paz, incluso en medio del caos ✨",
      imageLink: "/welcome/es_content_tired_paid_q3.png",
      subtitle:
        "Ser mamá o papá no es fácil, pero no estás sola/o. Hemos preparado 3 técnicas  efectivas basadas en psicología para ayudarte a recuperar el equilibrio, tanto en los días duros como en el corre-corre diario.",
      button: "Ver técnicas 👀",
    },
    4: {
      typeInfo: "noQuestions",
      title: "Nombra lo que sientes 💚",
      imageLink: "/welcome/es_content_tired_paid_q4.png",
      subtitle:
        "Cuando sientas que estás por explotar, intenta decir en voz baja lo que estás sintiendo: “Estoy agotada”, “Me siento ignorado”. Los estudios muestran que ponerle nombre a una emoción ayuda a bajar la tensión y calmarse más rápido.",
        button: "Siguiente ➡️",
    },
    5: {
      typeInfo: "noQuestions",
      title: "Trabaja con tus pensamientos 🧠",
      imageLink: "/welcome/es_content_tired_paid_q5.png",
      subtitle:
        "Las emociones no nacen solo de lo que pasa, sino de lo que pensamos sobre lo que pasa. Por ejemplo, tu hijo saca una mala nota. Lo que sientas dependerá de lo que pienses.",
        button: "¿Qué hago con eso?",
    },
    6: {
      typeInfo: "noQuestions",
      title: "Prueba escribir un diario 📝",
      imageLink: "/welcome/es_content_tired_paid_q6.png",
      subtitle:
        "Anotar lo que sientes te ayuda a entender qué te está afectando… y a ver las cosas desde otra perspectiva. Por ejemplo: “Las calificaciones son solo una forma de aprender. Podemos con esto juntos.” Es simple, pero poderoso.",
        button: "Tiene sentido 👍",
    },
    7: {
      typeInfo: "noQuestions",
      title: "Ritual para recargarte 🔋",
      imageLink: "/welcome/es_content_tired_paid_q7.png",
      subtitle:
        "Tómate 10–15 minutos y haz una lista de cosas que te recargan: caminar, escuchar música, estar en silencio…lo que a ti te funcione. Elige una y hazla todos los días. Pequeños descansos = más fuerza mental.",
        button: "¿Qué más?",
    },
    8: {
      typeInfo: "noQuestions",
      title: "Tómate un respiro, a tu hijo le va a encantar 😍",
      imageLink: "/welcome/es_content_tired_paid_q8.png",
      subtitle:
        "Acabas de hacer algo bueno por tu bienestar mental 💛 ¿Y si vas un paso más allá? A veces no cuidamos de nosotros porque no tenemos tiempo. Por eso tenemos un regalo especial que puede ayudarte a encontrarlo…",
        button: "¿Qué es?",
    },
    9: {
      typeInfo: "noQuestions",
      title: "Consigue una clase gratuita para tu hijo 🎉",
      imageLink: "/welcome/es_content_tired_paid_q9.png",
      subtitle:
        "Somos Kodland, una plataforma online de educación internacional donde niños aprenden a programar, crear videojuegos y expresarse. Con apoyo real de tutores y clases en grupo… tú puedes por fin respirar con calma 💙",
        button: "Saber más 👀",
    },
    10: {
      typeInfo: "noQuestions",
      title: "¿Cómo es la clase?",
      imageLink: "/welcome/es_content_tired_paid_q10.png",
      subtitle:
        "La clase de prueba es una oportunidad para conocer Kodland y probar la programación en vivo ✨",
        button: "¿Qué opinan los padres?",
    },
    11: {
      typeInfo: "noQuestions",
      title: "Más de 200,000 familias ya confiaron en Kodland 💙",
      imageLink: "/welcome/reviews-latam.png",
      subtitle:
        "Lee lo que dicen y anímate a probarlo tú también. Quizás sea justo lo que tu hijo estaba buscando (y tú también).",
        button: "Quiero probar 👍",
    },
    12: {
      title: "¿Qué edad tiene tu hijo/a?",
      type: "age",
      button: "",
    },
    13: {
      question:
        "¿Tienes una computadora de escritorio o portátil en la que tu hijo puede jugar o estudiar?",
      answers: [
        "Si ✅",
        {
          answer: "☹️ No",
          stopAnswer: true,
        },
      ],
    },
    14: {
      typeInfo: "noQuestions",
      title: "¿Y cómo acceder a la clase?",
      subtitle:
        "Esta clase gratuita está disponible por tiempo limitado. Solo tienes que completar el formulario en el siguiente paso y elegir el horario que más les convenga. Después, te pediremos confirmar tu participación por WhatsApp ¡y listo! 💙",
        button: "Reservar mi clase gratuita 🔥",
    },
    15: {
      title: "Inscríbete a una clase de prueba gratuita",
      type: "one-page-contacts",
      subtitle:
        "Conversemos, conoce nuestro método y descubre todo lo que tu hijo puede aprender con nosotros.",
        button: " Elige una fecha ➡️",
    },
    16: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    17: {
      title: "Revisa estos detalles para completar el registro ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Ten en cuenta que para la lección necesitaras una PC o laptop en funcionamiento y que deberás acompañar a tu hijo/a durante toda la clase. Recuerda que la misma es individual y personalizada.",
      button: "¿Qué más?",
    },
    18: {
      title: "Chequea tu correo y WhatsApp antes de la clase de prueba📞",
      typeInfo: "whatsapp",
      subtitle:
        "24hs antes estaremos enviándote un recordatorio y 2 horas antes de la clase te pediremos que confirmes tu asistencia. Es muy importante que estemos en contacto para que la clase no se cancele.",
      button: "¿Qué más?",
    },
    19: {
      title: "La clase se realizará en nuestra plataforma 💻",
      typeInfo: "classroom",
      subtitle:
        "Recibirás un enlace y un código único por WhatsApp y correo electrónico. Solo haz clic en el enlace y te llevará directo a la clase. Sin apps adicionales, sin descargas.",
      button: "Entendido ✅",
    },
  },
};